// extracted by mini-css-extract-plugin
export default {"root":"styles-module-root-d4e5db"};